<div class="ia-sort-field">
  <label [for]="id">Sort by</label>
  <select [id]="id" [ngModel]="selectedField" (ngModelChange)="choose($event)">
    <option *ngIf="!selectedOption" [value]="field || ''" disabled>{{ fallbackLabel }}</option>
    <option *ngFor="let option of options" [value]="option.field">{{ option.title }}</option>
  </select>
</div>
<button type="button" class="btn btn-secondary ia-sort-direction" (click)="directionRequested.emit()"
  [attr.aria-label]="(ascending ? 'Ascending. Switch to descending' : 'Descending. Switch to ascending')"
  [title]="ascending ? 'Ascending: smallest to largest. Switch to descending.' : 'Descending: largest to smallest. Switch to ascending.'">
  <span aria-hidden="true">{{ ascending ? '↑' : '↓' }}</span>{{ ascending ? 'Ascending' : 'Descending' }}
</button>
